import React from 'react';
import { FaUndo } from 'react-icons/fa';
import { JobType } from '../services/jobPostingService';

interface FiltersSidebarProps {
  filters: {
    jobTypes: JobType[];
    positions: string[];
  };
  onJobTypeToggle: (jobType: JobType) => void;
  onPositionToggle: (position: string) => void;
  onApplyFilters: () => void;
  onClearFilters: () => void;
  positionOptions: string[];
}

const FiltersSidebar: React.FC<FiltersSidebarProps> = ({
  filters,
  onJobTypeToggle,
  onPositionToggle,
  onApplyFilters,
  onClearFilters,
  positionOptions,
}) => {
  return (
    <div className="bg-white rounded-lg shadow-md p-6 sticky top-28">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-lg font-semibold text-gray-900">Filters</h3>
        <button
          onClick={onClearFilters}
          className="flex items-center space-x-1 text-gray-600 hover:text-gray-800 transition-colors relative group"
        >
          <span className="text-xs">Clear filters</span>
          <FaUndo className="w-2 h-2" />
          <span className="absolute bottom-0 left-0 right-0 h-[1px] bg-gray-800 scale-x-0 group-hover:scale-x-100 transition-transform origin-left"></span>
        </button>
      </div>

      {/* Job Type Filter */}
      <div className="mb-6">
        <h3 className="text-sm font-semibold text-gray-700 mb-3">Job Type</h3>
        <div className="space-y-2">
          <label className="flex items-center">
            <input
              type="checkbox"
              checked={filters.jobTypes.includes(JobType.FULL_TIME)}
              onChange={() => onJobTypeToggle(JobType.FULL_TIME)}
              className="rounded border-gray-300 text-blue-600 focus:ring-blue-500"
            />
            <span className="ml-2 text-sm text-gray-700">Full-Time</span>
          </label>
          <label className="flex items-center">
            <input
              type="checkbox"
              checked={filters.jobTypes.includes(JobType.PART_TIME)}
              onChange={() => onJobTypeToggle(JobType.PART_TIME)}
              className="rounded border-gray-300 text-blue-600 focus:ring-blue-500"
            />
            <span className="ml-2 text-sm text-gray-700">Part-Time</span>
          </label>
        </div>
      </div>

      {/* Position Filter */}
      <div className="mb-6">
        <h3 className="text-sm font-semibold text-gray-700 mb-3">Position</h3>
        <div className="space-y-2">
          {positionOptions.map((position) => (
            <label key={position} className="flex items-center">
              <input
                type="checkbox"
                checked={filters.positions.includes(position)}
                onChange={() => onPositionToggle(position)}
                className="rounded border-gray-300 text-blue-600 focus:ring-blue-500"
              />
              <span className="ml-2 text-sm text-gray-700">{position}</span>
            </label>
          ))}
        </div>
      </div>

      {/* Apply Button */}
      <button
        onClick={onApplyFilters}
        className="w-full bg-blue-600 text-white px-4 py-3 rounded-md hover:bg-blue-700 transition-colors font-semibold"
      >
        Apply Filters
      </button>
    </div>
  );
};

export default FiltersSidebar;

